import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { pickState } from '../_core/pickState';
import useParameterStore from '../parameterStore/useParameterStore';
import { keysToPersist, routeStore } from './routeStore';

const useRouteStore = createStore({
  creator: routeStore({
    location: window.location,
    useParameterStore: lazyDependency(() => useParameterStore),
  }),
  id: 'route',
  middlewares: {
    devtools: true,
    persist: {
      partialize(state) {
        return pickState(state, keysToPersist);
      },
    },
  },
});

export default useRouteStore;
